import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { GuardSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { GetRequestBaseResponseSchema, GuardsFilterSchema } from "../ea.schema.query";

const base = "guards";
const guards = createEndpointBase(base);

export const guardsEndpoints = {
  guardsGet: guards({
    method: "GET",
    path: "",
    request: z.object({ filter: GuardsFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(GuardSchemas["general"]),
    description: "Retrieves a list of execution guards with filtering support.",
  }),
  guardsCount: guards({
    method: "GET",
    path: "count",
    request: z.object({ filter: GuardsFilterSchema.pick({ where: true }).optional() }).optional(),
    response: CountResponseSchema,
    description: "Returns the total number of execution guards matching the filters.",
  }),
  guardsCreate: guards({
    method: "POST",
    path: "",
    request: GuardSchemas["createData"],
    response: z.any(),
    description: "Creates a new execution guard.",
  }),
  guardsUpdate: guards({
    method: "PATCH",
    path: ":id",
    request: GuardSchemas["update"],
    response: z.any(),
    description: "Updates an existing execution guard.",
  }),
  guardsDelete: guards({
    method: "DELETE",
    path: ":id",
    request: GuardSchemas["general"].pick({ id: true }),
    response: z.any(),
    description: "Permanently deletes an execution guard.",
  }),
} as const;
